import {ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {AppLoadingEventsEmitter} from '../../../shared/events/loading.events';
import {Constants} from '../../../shared/config/constants.config';
import {UsersService} from '../../../shared/services/users.service';
import {ReferralsStatisticViewModel, ReferralViewModel} from '../../../shared/viewModels/referral.viewModel';
import * as moment from 'moment';
import {forkJoin} from 'rxjs';
import {LocalisationService} from '../../../shared/services/localisation.service';
import {Languages} from '../../../shared/enums/languages';
import {Router} from '@angular/router';

@Component({
    selector: 'app-referrals',
    templateUrl: './referrals.component.html',
    styleUrls: ['./referrals.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ReferralsComponent implements OnInit {
    referrals: ReferralViewModel[] = [];
    referrals_statistics: ReferralsStatisticViewModel = new ReferralsStatisticViewModel();
    referral_name: string;
    is_en = false;

    constructor(
        private readonly usersService: UsersService,
        private readonly changeDetectorRef: ChangeDetectorRef,
        private readonly appLoadingEventsEmitter: AppLoadingEventsEmitter,
        private readonly constants: Constants,
        public readonly router: Router,
        private readonly localisationService: LocalisationService,
    ) {
    }

    ngOnInit() {
        this.appLoadingEventsEmitter.broadcastAppIsLoading(true);

        if (this.localisationService.getLanguage() === Languages.English) {
            this.is_en = true;
        }

        forkJoin([
            this.usersService.getUserProfile(),
            this.usersService.getReferrals(),
            this.usersService.getReferralsStatistic(),
        ])
            .subscribe(([userProfile, referrals, referrals_statistics]) => {
                this.referral_name = userProfile.referral_name;
                this.referrals = referrals;
                this.referrals_statistics = referrals_statistics;

                this.appLoadingEventsEmitter.broadcastAppIsLoading(false);
                this.changeDetectorRef.markForCheck();
            });
    }

    formatDate(date) {
        return moment(date).format('DD.MM.YYYY / HH:mm');
    }

    changeReferralName() {
        const newReferralName = prompt(this.localisationService.localise('enter_new_referral_name'), this.referral_name);

        if (newReferralName === null) {
            return;
        }

        this.appLoadingEventsEmitter.broadcastAppIsLoading(true);

        this.usersService.updateReferralName(newReferralName).subscribe(referral_name => {
            this.referral_name = referral_name.referral_name;

            this.appLoadingEventsEmitter.broadcastAppIsLoading(false);
            this.changeDetectorRef.markForCheck();
        }, () => {
            this.appLoadingEventsEmitter.broadcastAppIsLoading(false);
        });
    }

    copyUrl() {
        const el = document.createElement('textarea');
        el.value = 'https://agaia.life/' + (this.is_en ? 'en/' : '') + this.referral_name;
        document.body.appendChild(el);
        el.select();
        document.execCommand('copy');
        document.body.removeChild(el);
    }

}
